import React from 'react'
import { usePlayerStore } from '../store/player-store'

export default function MissionPopup(): React.ReactElement {
  const { pendingBonus, dismissBonus } = usePlayerStore()

  if (!pendingBonus) return null

  return (
    <div className="modal-overlay" onClick={dismissBonus}>
      <div className="modal-content" onClick={e => e.stopPropagation()} style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 36, marginBottom: 8 }}>🎁</div>
        <div className="modal-title">Daily Login Bonus</div>
        <div style={{ fontSize: 28, fontWeight: 800, color: '#f5c518', margin: '8px 0' }}>
          +{pendingBonus.bonus} 🪙
        </div>
        <div style={{ fontSize: 13, color: '#888', marginBottom: 16 }}>
          Day {pendingBonus.streak} streak
        </div>

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: 16, marginTop: 8 }}>
          <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 12 }}>Today's Missions</div>
          {pendingBonus.missions.map(m => (
            <div key={m.id} style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '8px 12px', background: 'rgba(255,255,255,0.05)', borderRadius: 8,
              marginBottom: 8, fontSize: 13,
            }}>
              <span>{m.title}</span>
              <span style={{ color: '#f5c518', fontWeight: 700 }}>+{m.reward}</span>
            </div>
          ))}
        </div>

        <button className="btn btn-primary" style={{ marginTop: 16, width: '100%' }} onClick={dismissBonus}>
          Let's Play!
        </button>
      </div>
    </div>
  )
}
